import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3033';
const base = `${apiUrl}/api/account`;

export const getAuthorizations = () => axios.get(base).then((r) => r.data.authorizations || []);
